export default __webpack_public_path__ + "static/media/house-8.6dd0469e.jpg";